import React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';

export type DeleteSnippetModalViewProps = {
  onClose: () => void;
  onSubmit: () => void;
  loading: boolean;
};

export const DeleteSnippetModalView = ({ onClose, onSubmit, loading }: DeleteSnippetModalViewProps): JSX.Element => {
  return (
    <Modal
      closeOnClickOutside={!loading}
      closeOnEsc={!loading}
      onClose={onClose}
      showCloseIcon={!loading}
      title={'Delete Snippet'}
      primaryButtonTitle={'Delete Snippet'}
      primaryButtonAction={onSubmit}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonDisabled={loading}
      primaryButtonLoading={loading}>
      <p>This snippet will be permanently deleted and cannot be recovered. Are you sure you want to proceed?</p>
    </Modal>
  );
};
